"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M3 18h12v-2H3zM3 6v2h18V6zm0 7h18v-2H3z"
}), 'Notes');